import { IconFn, IconSvg } from "../createIcon";

export const XIcon: IconFn = ({ color = "#B3B3B3", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 14, height: 14 }} {...props}>
    <path
      d="M14 1.41 12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7 14 1.41Z"
      fill={color}
    />
  </IconSvg>
);
